<template>
  <div>
    <nav-bar
      title="新闻"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      class="my-nav"
    />
    <div class="grey-box">
      <div style="margin-top: 45px"></div>
      <div class="ql-container ql-snow">
        <div style="text-align: center; line-height: 2rem; margin-top: 1rem">
          <div style="font-size: 1.5rem; font-weight: bold">
            {{ row.topic }}
          </div>
          <div style="text-align:center;font-size:12px;margin-top:10px">发布时间:{{ row.postDate }}</div>
          <div style="text-align:center;font-size:12px;margin-top:-10px">信息来源：{{ row.briefIntroduction }}</div>
        </div>
        <div style="text-align: end">
          <!-- <button @click="shareHandle" style="margin-right: 1rem">点此分享</button> -->
          <button @click="addFont" style="margin-right: 1rem">➕</button>
          <button @click="cutFont" style="margin-right: 1rem">➖</button>
        </div>

        <divider />
        <div
          class="ql-editor"
          :style="{ fontSize: fontSize }"
          data-gramm="false"
          contenteditable="false"
          data-placeholder="请输入内容"
          v-html="content"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { Cell, CellGroup, NavBar, Col, Divider } from "vant";
import service from "../../api/service";
//新闻详情
export default {
  name: "xwDetail",
  components: {
    Cell,
    CellGroup,
    NavBar,
    Col,
    Divider,
  },
  data() {
    return {
      row: "",
      xwId: "",
      sourcePath: "",
      contentId: "",
      content: "",
      fontSize: "1rem",
      fontSizeNumber: 1,
    };
  },
  mounted() {
    let q = this.$route.query;
    this.xwId = q.xwId;
    this.sourcePath = q.sourcePath;
    this.contentId = q.contentId;
    this.init();
    this.row = q.row
      ? JSON.parse(decodeURIComponent(q.row))
      : JSON.parse(sessionStorage.getItem("row"));
    this.shareHandle();
  },
  methods: {
    shareHandle() {
      let that = this;
      let q = this.$route.query;

      let obj = {
        title: this.row.topic,
        desc: '辽宁交投e工会',
        imgUrl: this.row.imgmin,
        row: {
          contentId: q.contentId,
          sourcePath: q.sourcePath,
          xwId: q.xwId,

          topic: this.row.topic,
          postDate: this.row.postDate,
          briefIntroduction: this.row.briefIntroduction,
        },
      };
      this.$wxUtils.share(obj);
      console.warn(obj);
    },
    onClickLeft() {
      if (window.history.length <= 1) {
        this.$router.push({ path: "/home" });
        return;
      }
      console.warn('back')
      this.$router.back();
    },
    init() {
      service
        .get("/api/xw/getContentById", {
          contentId: this.contentId,
        })
        .then((res) => {
          if (res.status === 200) {
            this.content = res.data.content;
          }
        });
    },
    addFont() {
      this.fontSizeNumber += 0.1;
      this.fontSize = this.fontSizeNumber + "rem";
    },
    cutFont() {
      this.fontSizeNumber -= 0.1;
      this.fontSize = this.fontSizeNumber + "rem";
    },
  },
};
</script>

<style>
</style>